"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
define('rs/form/form.controller',['require','exports','module','underscore','vertebrae','rs/form/form.view','rs/form/section.controller','rs/form/attachment.controller','rs/form/formobjects/factory','rs/form/boolean.dynamicproperty','rs/modals/upload/upload.controller','rs/modals/workflow/workflow.controller','rs/models/task','rs/models/assignment.builder','rs/helper','rs/errors','e3-modal','langs'],function (require, exports, module) {
  var _Vertebrae$Controller;
  var _ = require('underscore');
  var Vertebrae = require('vertebrae');
  var FormContentView = require('rs/form/form.view');
  var SectionController = require('rs/form/section.controller');
  var AttachmentController = require('rs/form/attachment.controller');
  var FormObjectFactory = require('rs/form/formobjects/factory');
  var BooleanDynamicProperty = require('rs/form/boolean.dynamicproperty');
  var UploadModal = require('rs/modals/upload/upload.controller');
  var WorkflowModal = require('rs/modals/workflow/workflow.controller');
  var Task = require('rs/models/task');
  var AssignmentBuilder = require('rs/models/assignment.builder');
  var helper = require('rs/helper');
  var RSError = require('rs/errors');
  var E3Modal = require('e3-modal');
  var langs = require('langs');
  var FormContentController = Vertebrae.Controller.extend((_Vertebrae$Controller = {
    properties: ['activeFormObject', 'activeSection', 'appController', 'assignmentFormObjects', 'assignmentFormObjectsMap', 'assignments', 'attachments', 'comments', 'commentCounts', 'delegate', 'documentLock', 'documentModel', 'formObjectArray', 'formObjectData', 'formObjectMap', 'initialSectionIndex', 'loaded', 'locked', 'maxFormObjectId', 'permissions', 'readOnly', 'saveHandlers', 'scrollMemory', 'sections', 'template', 'templateModel', 'unsavedAttachments', 'unsavedChanges', 'valid', 'workflowService'],
    observes: {
      'window-resize': 'resize'
    },
    events: {
      'view:ready': null
    },
    totalValidSectionCounter: 0,
    initialize: function initialize(properties) {
      this._super();
      this._setup = false;
      this._ready = false;
      this.applyProperties(properties);
      this.setMaxFormObjectId(1);
      this.setSaveHandlers([]);
      this.setAssignmentFormObjects([]);
      this.setAssignmentFormObjectsMap({});
      this.setFormObjectArray([]);
      this.setFormObjectMap({});
      this.formObjectData = this.formObjectData || {};
      this.setScrollMemory({});
      this.setPermissions(this.getWorkflowService() ? this.getWorkflowService().getDocumentService().getPermissions() || {} : {});
      this.setSections(this.initializeSections());
      this.setAttachments(this.initializeAttachments());
      this.sectionIDCounter = this.getSections().length;
      if (!this.isDesignerMode()) {
        this.sync('activeSection');
        this.sync('unsavedAttachments');
        this.sync('totalValidSectionCounter');
        this.sync('valid');
      }
      this._setup = true;
    },
    checkPermission: function checkPermission(permission) {
      return this.getAppController().checkPermission(permission);
    },
    getFormActions: function getFormActions() {
      var section = this.getActiveSection(),
        actions = null,
        canSave = this.getUnsavedAttachments() || section && section.getUnsavedChanges();
      actions = [{
        "class": 'form-pdf-generation-btn',
        action: 'pdf',
        text: 'CREATE PDF',
        icon: 'file'
      }, {
        action: 'compare',
        text: 'COMPARE',
        icon: 'columns'
      }, {
        action: 'save',
        text: 'SAVE',
        icon: 'save',
        disabled: !canSave
      }];
      var d = this.getDelegate();
      if (d && d.hasChecklists && d.hasChecklists()) {
        actions.unshift({
          action: 'showChecklist',
          text: 'SHOW CHECKLIST',
          icon: 'check-square'
        });
      }
      actions = actions.concat(this.getSectionActions());
      return actions;
    },
    isDocTypeCheckList: function isDocTypeCheckList() {
      return this.getTemplateModel().getDocumentType().toLowerCase() == 'checklist';
    },
    requestShowChecklistAction: function requestShowChecklistAction() {
      var d = this.getDelegate();
      if (d && _.isFunction(d.getChecklistController)) {
        var cc = d.getChecklistController();
        cc.toggleChecklist();
      }
    },
    getSectionActions: function getSectionActions() {
      var sectionIndex = this.getCurrentSectionIndex(true),
        that = this,
        actions = [];
      actions.push({
        action: 'previousSection',
        text: '',
        left: true,
        icon: 'chevron-left',
        noHide: true,
        disabled: sectionIndex < 1,
        ariaLabel: langs.phrase('Submissions.Edit.Actions.PreviousButton.ARIALabel')
      });
      actions.push({
        action: 'nextSection',
        text: '',
        icon: 'chevron-right',
        noHide: true,
        disabled: this.isActiveSectionLastVisible(),
        ariaLabel: langs.phrase('Submissions.Edit.Actions.NextButton.ARIALabel')
      });
      return actions;
    },
    requestShowHiddenAction: function requestShowHiddenAction() {
      this.getView().showFormActionsDropdown(this.getFormActions());
    },
    canHaveToolbarActions: function canHaveToolbarActions() {
      return !this.getTemplateModel().preview;
    },
    canAddComments: function canAddComments() {
      var permissions = this.getPermissions();
      return !this.isPreviewMode() && permissions.canWriteComments;
    },
    canViewAnswerHistory: function canViewAnswerHistory() {
      return true;
    },
    hasAnswers: function hasAnswers() {
      return !this.noSavesInAnswers;
    },
    isValid: function isValid() {
      return !!this.getValid();
    },
    showLoading: function showLoading() {
      return this.getAppController().showLoading();
    },
    progressiveDisclosureEnabled: function progressiveDisclosureEnabled() {
      return true;
    },
    loadingForPromise: function loadingForPromise() {
      return this.showLoading();
    },
    getSections: function getSections() {
      return this.get('sections');
    },
    locksDidUpdate: function locksDidUpdate() {
      var locker = this.getDocumentLock(),
        sections = this.getSections(),
        that = this,
        i = 0,
        len = sections.length;
      for (i = 0; i < len; i++) {
        (function (section) {
          if (section.isExternallyLocked()) {
            section.lock();
          } else {
            if (section.isLocked()) {
              section.requestAnswerUpdate().then(function () {
                section.unlock();
              });
            } else {
              section.unlock();
            }
          }
        })(sections[i]);
      }
    },
    lockCurrentSection: function lockCurrentSection() {
      var section = this.getActiveSection();
      section.lock();
    },
    unlockCurrentSection: function unlockCurrentSection() {
      var section = this.getActiveSection();
      section.unlock();
    },
    lockSectionByID: function lockSectionByID(id) {
      var section = this.getFormObjectByID(id);
      if (section && section.lock) {
        section.lock();
      }
    },
    getAnswerDataForFormObject: function getAnswerDataForFormObject() {},
    getAnswerData: function getAnswerData(options) {
      var _processChildren = null,
        attachmentArray = [];
      options = _.defaults(options || {}, {
        active: true,
        all: false
      });
      _processChildren = function processChildren(parent, data) {
        var i = 0,
          fo = null,
          children = parent.getChildren(),
          value = null,
          handlers = [],
          len = children ? children.length : 0;
        for (i = 0; i < len; ++i) {
          fo = children[i];
          if (fo.isAnswerable === true) {
            value = fo.getValue ? fo.getValue() : null;
            if (value != null) {
              data.push({
                id: fo.getId(),
                value: value + ''
              });
            }
          } else if (fo.isAttachmentBtn === true) {
            var attachment = fo.getAttachController();
            if (attachment && !attachment._processed) {
              attachment._processed = true;
              attachmentArray.push(attachment);
              value = attachment.getValue ? attachment.getValue() : null;
              if (value) {
                data.push({
                  id: attachment.getId(),
                  value: JSON.stringify(value)
                });
              }
            }
          }
          _processChildren(fo, data);
        }
      };
      var finalData = [];
      if (options.all) {
        var sections = this.getSections(),
          section = null,
          len = sections ? sections.length : 0,
          i = 0;
        for (i = 0; i < len; ++i) {
          section = sections[i];
          if (section.hasUnsavedChanges()) {
            _processChildren(section, finalData);
          }
        }
      } else if (options.active) {
        _processChildren(this.getActiveSection(), finalData);
      }
      _.each(attachmentArray, function (attachment) {
        attachment._processed = null;
      });
      return finalData;
    },
    activateSection: function activateSection(section) {
      var that = this,
        documentModel = this.getDocumentModel(),
        waitForLock = null;
      return Promise.resolve(this.deactivateCurrentSection()).bind(this).tap(function () {
        if (this.shouldCheckUnsaved() && section.getValue() != 'viewed') {
          section.setValue('viewed', true);
          section.refreshValidity();
          return this.getDocumentLock().setLock(section.getId()).bind(this).then(function () {
            return documentModel.saveAnswerData([{
              id: section.getId(),
              value: 'viewed'
            }], section.getId());
          }).caught(function () {}).then(function () {
            return this.getDocumentLock().releaseLock(section.getId());
          });
        }
      }).tap(function () {
        this.getView().activateSection(section);
        this.setActiveSection(section);
        section.show();
        this.loadScrollForSection(section);
        this.updateSectionRoute();
        return this.refreshComments();
      }).lastly(this.showLoading());
    },
    activateNextVisibleSection: function activateNextVisibleSection() {
      var visibleSections = this.getVisibleSections(),
        index = _.indexOf(visibleSections, this.getActiveSection()),
        nextIndex = index + 1;
      if (!visibleSections[nextIndex]) {
        nextIndex = 0;
      }
      this.resetScrollMemoryForSection(visibleSections[nextIndex]);
      return this.activateSection(visibleSections[nextIndex]);
    },
    activatePreviousVisibleSection: function activatePreviousVisibleSection() {
      var visibleSections = this.getVisibleSections(),
        index = _.indexOf(visibleSections, this.getActiveSection()),
        previousIndex = index - 1;
      if (!visibleSections[previousIndex]) {
        previousIndex = visibleSections.length - 1;
      }
      this.resetScrollMemoryForSection(visibleSections[previousIndex]);
      return this.activateSection(visibleSections[previousIndex]);
    },
    updateSectionRoute: function updateSectionRoute() {
      var sectionIndex = this.getCurrentSectionIndex(),
        firstTime = true,
        templateId = this.getTemplateModel().getId();
      this._hasUpdatedRoute = true;
      if (this.isPreviewMode()) {
        this.getAppController().navigateTemplate(this.getTemplateModel(), {
          trigger: false,
          replace: firstTime
        }, sectionIndex, true);
      } else if (this.isDesignerMode()) {
        this.getAppController().navigateTemplate(this.getTemplateModel(), {
          trigger: false,
          replace: firstTime
        }, sectionIndex);
      } else {
        this.getAppController().navigateDocument(this.getDocumentModel(), {
          trigger: false,
          replace: firstTime
        }, sectionIndex);
      }
    },
    getCurrentSectionIndex: function getCurrentSectionIndex(basedOnVisibility) {
      return _.indexOf(basedOnVisibility ? this.getVisibleSections() : this.getSections(), this.getActiveSection());
    },
    isActiveSectionLastVisible: function isActiveSectionLastVisible() {
      return this.getActiveSection() === this.getLastVisibleSection();
    },
    isReadOnly: function isReadOnly() {
      var permissions = this.getPermissions(),
        readOnly = this.getReadOnly();
      if (permissions) {
        readOnly = permissions.canWrite == false || readOnly;
      }
      return readOnly;
    },
    getLastVisibleSection: function getLastVisibleSection() {
      return _.last(this.getVisibleSections());
    },
    getVisibleSections: function getVisibleSections() {
      return _.filter(this.getSections(), function (section) {
        return section.getVisible();
      });
    },
    shouldRenderFooter: function shouldRenderFooter() {
      return true;
    },
    shouldCheckUnsaved: function shouldCheckUnsaved() {
      return !this.isPreviewMode() && !this.getReadOnly();
    },
    deactivateCurrentSection: function deactivateCurrentSection() {
      var section = this.getActiveSection(),
        that = this;
      if (section) {
        this.saveScrollForSection(section);
        if (this.shouldCheckUnsaved() && section.getUnsavedChanges()) {
          return this.showUnsavedSectionChangesDialog().then(function () {
            return that._deactivateCurrentSection();
          });
        } else {
          return this._deactivateCurrentSection();
        }
      }
    },
    _deactivateCurrentSection: function _deactivateCurrentSection() {
      var section = this.getActiveSection();
      this.setActiveSection(null);
      section.hide();
      this.getView().deactivateSection(section);
      return this.releaseActiveLock(section);
    },
    releaseActiveLock: function releaseActiveLock(section) {
      var activeSection = section || this.getActiveSection();
      if (this.isLockingEnabled()) {
        return this.getDocumentLock().releaseLock(activeSection.id);
      }
    },
    showUnsavedSectionChangesDialog: function showUnsavedSectionChangesDialog() {
      var that = this;
      return that.requestSaveAction().lastly(that.showLoading());
    },
    showUnsavedChangesDialog: function showUnsavedChangesDialog() {
      var that = this;
      return E3Modal.BtnMsgModal.show({
        title: 'Warning',
        message: 'You have unsaved changes, do you want to continue and discard your changes?',
        buttons: ['No', {
          text: 'Yes',
          color: 'danger'
        }]
      }).then(function (btn) {
        if (btn == 'No') {
          return Promise.reject().ignore();
        }
      });
    },
    saveScrollForSection: function saveScrollForSection(section) {
      var id = section.getId(),
        scroll = section.getCurrentScroll(),
        memory = this.getScrollMemory();
      memory[id] = scroll;
    },
    loadScrollForSection: function loadScrollForSection(section) {
      var id = section.getId(),
        memory = this.getScrollMemory(),
        scroll = memory[id] || 0;
      section.setCurrentScroll(scroll);
    },
    resetScrollMemoryForSection: function resetScrollMemoryForSection(section) {
      var id = section.getId(),
        memory = this.getScrollMemory();
      memory[id] = 0;
    },
    initializeSections: function initializeSections() {
      var template = this.getTemplate() || {},
        sections = template.children || [],
        that = this;
      return _.map(sections, function (section) {
        return that.registerSection(new SectionController(section, that));
      });
    },
    initializeAttachments: function initializeAttachments() {
      var template = this.getTemplate() || {},
        that = this;
      return _.map(template.attachments, function (attachment) {
        return that.registerAttachment(new AttachmentController(attachment, that));
      });
    },
    initializeFormObjectsArray: function initializeFormObjectsArray(formObjects, owner) {
      var that = this,
        formObject = null,
        ctor = null;
      return _.map(formObjects, function (fo, i) {
        if (fo.type == 'group') {
          fo.type = 'question';
        }
        ctor = that.getFormObjectByType(fo.type);
        formObject = new ctor(fo, owner);
        formObject.setRowIndex(i);
        return that.registerFormObject(formObject);
      });
    },
    initializeDependencyArray: function initializeDependencyArray(dependencies, owner) {
      var len = dependencies ? dependencies.length : 0,
        dependencyTypeArray = [],
        dependencyTypeMap = {},
        formObject = null,
        dependencyArray = [],
        dep = null,
        i = 0;
      for (i = 0; i < len; ++i) {
        dep = dependencies[i];
        if (!dependencyTypeMap[dep.type]) {
          dependencyTypeMap[dep.type] = [];
          dependencyTypeArray.push({
            type: dep.type,
            dependencies: dependencyTypeMap[dep.type]
          });
        }
        formObject = this.getFormObjectByID(dep.targetId);
        if (formObject) {
          dependencyTypeMap[dep.type].push(formObject);
          dependencyArray.push({
            type: dep.type,
            target: formObject
          });
        }
      }
      len = dependencyTypeArray.length;
      for (i = 0; i < len; ++i) {
        if (dependencyTypeArray[i].dependencies.length) {
          this.initializeDynamicProperty(dependencyTypeArray[i], owner);
        }
      }
      return dependencyArray;
    },
    initializeDynamicProperty: function initializeDynamicProperty(dependencyType, owner) {
      var key = dependencyType.type == 'attach' ? 'displayed' : 'absoluteValid',
        dp = new BooleanDynamicProperty(dependencyType.dependencies, owner, key),
        dependencies = dp.getDependencies() || [],
        len = dependencies.length,
        i = 0;
      for (i = 0; i < len; ++i) {
        dependencies[i].addDependentByProperty(dependencyType.type, owner);
      }
      if (!this.isDesignerMode()) {
        owner.set(dependencyType.type, dp);
        dp.start();
      }
    },
    setupSections: function setupSections() {
      var sections = this.getSections(),
        len = sections.length,
        i = 0,
        locked = !!this.getLocked(),
        view = this.getView();
      for (i = 0; i < len; ++i) {
        sections[i].setup(view.createSectionElement());
        sections[i].setupFormObject();
        if (locked) {
          sections[i].lock();
        }
      }
      if (!_.isEmpty(this.getComments())) {
        this.assignCommentsToSections();
      }
    },
    setupAttachments: function setupAttachments() {
      var attachments = this.getAttachments(),
        len = attachments.length,
        i = 0,
        view = this.getView();
      for (i = 0; i < len; ++i) {
        attachments[i].setupFormObject();
        if (!this.isDesignerMode()) {
          attachments[i].processDocuments();
        }
      }
      if (len == 0 && !this.isDesignerMode()) {
        view.hideAttachmentHeader();
      }
      this._attachmentsInitialized = true;
    },
    getFormObjectByName: function getFormObjectByName(name) {
      var allFo = this.getFormObjectArray(),
        i = 0,
        len = allFo.length;
      for (i = 0; i < len; i++) {
        if (allFo[i].name == name) {
          return allFo[i];
        }
      }
      return null;
    },
    generateFormObjectName: function generateFormObjectName(prefix, numberSuggestion) {
      var prefCache = this._namePrefixCache = this._namePrefixCache || {};
      var numberToTry = 1;
      if (numberSuggestion != null) {
        numberToTry = numberSuggestion;
      } else if (prefCache[prefix] != null) {
        numberToTry = prefCache[prefix] + 1;
      } else {
        numberToTry = 1;
      }
      while (this.getFormObjectByName(prefix + String(numberToTry)) != null) {
        numberToTry++;
      }
      var name = prefix + String(numberToTry);
      prefCache[prefix] = numberToTry;
      return name;
    },
    attachDidChange: function attachDidChange() {
      var someVisible = _.some(this.getAttachments(), function (a) {
        return a.getAttach();
      });
      if (someVisible && this.isDesignerMode()) {
        this.getView().showAttachmentHeader();
      } else {
        this.getView().hideAttachmentHeader();
      }
    },
    registerAttachment: function registerAttachment(attachment) {
      this.sync('attach', {
        target: attachment
      });
      this.registerFormEntity(attachment);
      return attachment;
    },
    registerFormObject: function registerFormObject(formObject) {
      var that = this;
      this.registerFormEntity(formObject);
      this.listenTo(formObject, 'supremeValidity', function () {
        that.formObjectValidityDidChange(formObject);
        that.debounceRefreshComments();
      });
      return formObject;
    },
    debounceRefreshComments: function debounceRefreshComments() {
      if (!this.debounceCommentRefresh) {
        this.debounceCommentRefresh = _.debounce(this.refreshComments, 400);
      }
      this.debounceCommentRefresh();
    },
    formObjectValidityDidChange: function formObjectValidityDidChange(formObject) {
      var sectionController = formObject.getSectionController();
      if (sectionController && this._ready) {
        sectionController.refreshValidity();
      }
    },
    registerSection: function registerSection(section) {
      this.registerFormEntity(section);
      this.listenTo(section, 'change:absoluteValid', function () {
        this.sectionValidityDidChange(section);
      });
      this.listenTo(section, 'change:displayed', this.checkFormValidity);
      this.listenTo(section, 'change:valid', this.checkFormValidity);
      return section;
    },
    sectionValidityDidChange: function sectionValidityDidChange(section) {
      if (section.getAbsoluteValid()) {
        this.totalValidSectionCounter++;
      } else {
        this.totalValidSectionCounter ? this.totalValidSectionCounter-- : null;
      }
    },
    checkFormValidity: function checkFormValidity() {
      if (this.totalValidSectionCounter >= this.getVisibleSections().length) {
        this.setValid(true);
      } else {
        this.setValid(false);
      }
    },
    refreshValidPropertyOnView: function refreshValidPropertyOnView(valid) {
      this.refreshActions();
      if (valid) {
        this.getView().enableSidebarAction();
      } else {
        this.getView().disableSidebarAction();
      }
    },
    registerFormEntity: function registerFormEntity(formObject) {
      var formObjectMap = this.getFormObjectMap(),
        formObjectArray = this.getFormObjectArray();
      formObjectArray.push(formObject);
      formObjectMap[formObject.id] = formObject;
      this.checkMaxFormObjectID(formObject);
    },
    clearFormObjectById: function clearFormObjectById(id) {
      var formObjectMap = this.getFormObjectMap(),
        formObjectArray = this.getFormObjectArray(),
        fo = formObjectMap[id],
        index = null;
      if (fo) {
        formObjectMap[id] = null;
        index = _.indexOf(formObjectArray, fo);
        if (index > -1) {
          formObjectArray.splice(index, 1);
        }
      }
      return fo;
    },
    getFormObjectByID: function getFormObjectByID(id) {
      return this.getFormObjectMap()[id];
    },
    getFormObjectDataByID: function getFormObjectDataByID(id) {
      var data = this.getFormObjectData()[id];
      return data != null ? data.value : null;
    },
    getFormObjectCommentCountByID: function getFormObjectCommentCountByID(id) {
      var commentCounts = this.getCommentCounts() || {};
      return commentCounts[id] ? commentCounts[id].count || 0 : 0;
    },
    getFormObjectCommentUnreadCountByID: function getFormObjectCommentUnreadCountByID(id) {
      var commentCounts = this.getCommentCounts() || {};
      return commentCounts[id] ? commentCounts[id].unread || 0 : 0;
    },
    checkMaxFormObjectID: function checkMaxFormObjectID(control) {
      var id = Number(control.get('id')),
        maxId = this.getMaxFormObjectId();
      if (!_.isNaN(id) && maxId < id) {
        this.setMaxFormObjectId(id + 1);
      }
    },
    createId: function createId() {
      var maxId = this.getMaxFormObjectId();
      this.setMaxFormObjectId(maxId + 1);
      this._clientGeneratedIds = this._clientGeneratedIds || [];
      this._clientGeneratedIds.push(maxId);
      this.setUnsavedChanges(true);
      return maxId;
    },
    getFormObjectByType: function getFormObjectByType(type) {
      return FormObjectFactory.getFormObjectByType(type);
    },
    getFormController: function getFormController() {
      return this;
    }
  }, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_Vertebrae$Controller, "getVisibleSections", function getVisibleSections() {
    return _.filter(this.getSections(), function (section) {
      return section.getDisplayed();
    });
  }), "getFormObjectsWithDependencies", function getFormObjectsWithDependencies() {
    return _.filter([].concat(this.getFormObjectArray()).concat(this.getSections()), function (fo) {
      return fo.getDependencies().length > 0;
    });
  }), "getAllInvalidRequiredFormObjects", function getAllInvalidRequiredFormObjects() {
    var allInvalidFo = [],
      sections = this.getSections(),
      i = 0,
      len = sections.length;
    for (i = 0; i < len; i++) {
      allInvalidFo = allInvalidFo.concat(sections[i].getInvalidRequiredFormObjects());
    }
    return allInvalidFo;
  }), "assignCommentsToSections", function assignCommentsToSections() {
    var comments = this.getComments() || [],
      sections = this.getSections() || [],
      sectionLength = sections.length;
    filtered = [], comment = null, fo = null;
    for (var i = 0; i < sectionLength; i++) {
      sections[i].setComments([]);
    }
    for (var j = 0, len = comments.length; j < len; j++) {
      comment = comments[j];
      fo = this.getFormObjectByID(comment.templateObjectId);
      if (fo.isVisible()) {
        fo.getSectionController().getComments().push(comment);
        filtered.push(comment);
      }
    }
    for (var k = 0; k < sectionLength; k++) {
      sections[k].refreshSidebar();
    }
    this.setComments(filtered);
  }), "displayFormObjectComments", function displayFormObjectComments(formObjectId) {
    var formObject = this.getFormObjectByID(formObjectId);
    return this.revealFormObject(formObject).lastly(this.showLoading()).tap(function () {
      return formObject.displayCommentContainer();
    }).tap(function () {
      return this.highlightFormObject(formObject);
    });
  }), "refreshComments", function refreshComments() {
    if (this.isDiffViewer() || this.isDesignerMode() || this.isPreviewMode() || this.isPDFMode()) {
      return Promise.resolve();
    }
    return this.getDocumentModel().requestCommentDigest().bind(this).then(function (comments) {
      this.setComments(comments);
      this.assignCommentsToSections();
    });
  }), "locateFormObject", function locateFormObject(formObject) {
    return this.revealFormObject(formObject).then(function () {
      this.highlightFormObject(formObject);
    }.proxy(this));
  }), "setupView", function setupView() {
    this.setView(new FormContentView());
  }), "viewIsReady", function viewIsReady() {
    this.getView().render();
    this.getView().renderSidebar(this.getSections(), this.getAttachments());
    this.setupSections();
    this.setupAttachments();
    var sections = this.getSections() || [],
      firstSection = sections[this.getInitialSectionIndex()] || sections[0];
    Promise.attempt(function () {
      if (this.shouldActivateDefaultSection()) {
        if (firstSection && !firstSection.getDisplayed()) {
          firstSection = sections[0];
        }
        if (firstSection) {
          return this.activateSection(firstSection).bind(this).then(function () {
            if (this.isDesignerMode()) {
              return this.activateFormObject(firstSection, true);
            }
          });
        }
      }
    }, null, this).bind(this).tap(function () {
      if (!this.isDesignerMode() && this.hasUnsavedSections() && !this.hasAnswers() && !this.isPDFMode()) {
        return this.requestSaveAction({
          all: true
        });
      }
    }).then(function () {
      this.setLoaded(true);
      this._ready = true;
      this.getView().setRendered();
      if (!this.isDesignerMode()) {
        _.invoke(this.getSections(), 'refreshValidity');
      }
    });
  }), "shouldActivateDefaultSection", function shouldActivateDefaultSection() {
    return true;
  }), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_Vertebrae$Controller, "isLoaded", function isLoaded() {
    return this.getLoaded();
  }), "resize", function resize() {
    if (this.getView() && this.getView().isAvailable()) {
      this.getView().resize();
    }
  }), "trySetValue", function trySetValue(formObject, oldValue, newValue) {
    if (!this.canEditDocument()) {
      formObject.setValue(oldValue, {
        silent: true
      });
      formObject.getView().refresh();
      var d = Promise.defer();
      setTimeout(d.reject, 500);
      return d.promise;
    }
    var sectionId = formObject.getSectionController().getId(),
      documentLock = this.getDocumentLock();
    return documentLock.setLock(sectionId).then(function () {
      if (newValue != null) {
        formObject.setValue(newValue, {
          silent: true
        });
      }
    }).caught(RSError.DomainIsLocked, function (e) {
      formObject.setValue(oldValue, {
        silent: true
      });
      formObject.getView().refresh();
      throw e;
    });
  }), "applyAnswerData", function applyAnswerData(answers) {
    var i = 0,
      a = null,
      len = answers ? answers.length : 0,
      fo = null;
    for (i = 0; i < len; ++i) {
      a = answers[i];
      fo = this.getFormObjectByID(a.id);
      if (fo) {
        fo.setValue(a.value, {
          silent: true
        });
        fo.getView().refresh();
      }
    }
  }), "activateFormObject", function activateFormObject(control, noProperties) {
    if (this.isDesignerMode()) {
      this.previousFormObject = this.getActiveFormObject();
    }
    this.setActiveFormObject(control);
    this.getView().activateFormObject(control.getView(), noProperties);
    this.previousFormObject = null;
  }), "setActiveFormObject", function setActiveFormObject(fo) {
    var current = this.getActiveFormObject();
    if (current) {
      this.stopListening(current);
    }
    this.set('activeFormObject', fo);
    this.listenTo(fo, 'change', function () {
      if (!this.getView().currentlyEditing) {
        this.triggerRefreshPropertiesTab();
      }
      this.getView().currentlyEditing = false;
      this.activeFormObjectDidChange();
    });
  }), "triggerRefreshPropertiesTab", function triggerRefreshPropertiesTab() {}), "refreshPropertiesTab", function refreshPropertiesTab() {}), "activeFormObjectDidChange", function activeFormObjectDidChange() {
    this.formObjectDidChange();
  }), "formObjectValueDidChange", function formObjectValueDidChange() {
    if (this._setup) {
      this.refreshActions();
    }
  }), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_Vertebrae$Controller, "formObjectDidChange", function formObjectDidChange() {
    this.setUnsavedChanges(true);
  }), "attachmentDidChange", function attachmentDidChange() {
    if (this._attachmentsInitialized) {
      this.setUnsavedAttachments(true);
    }
  }), "formObjectWasDeleted", function formObjectWasDeleted(control) {
    return Promise.attempt(function () {
      if (!this.getActiveSection()) {
        return this.activateSection(this.getSections()[0]);
      }
    }, null, this).bind(this).then(function () {
      if (control === this.getActiveFormObject()) {
        var active = this.getActiveSection();
        active && this.activateFormObject(active);
      }
      this.getView().formObjectWasDeleted(control.view);
      this.clearFormObjectById(control.get('id'));
      if (control.type == 'personfinder' && control.hasAssignmentType()) {
        this.clearAssignmentFormObject(control.getAssignmentType(), control);
      }
      control.unload();
      control.destroy();
      this.setUnsavedChanges(true);
    });
  }), "getTemplateProperties", function getTemplateProperties() {
    var templateModel = this.getTemplateModel(),
      documentModel = this.getDocumentModel(),
      title = null,
      label = null;
    if (documentModel) {
      title = documentModel.getStudyTitle() + ' - ' + documentModel.getTemplateType();
      label = documentModel.getStudyLabel();
    }
    return {
      headerTitle: 'Sections',
      title: title,
      label: label,
      preview: templateModel.preview,
      templateTitle: templateModel.title
    };
  }), "refreshActiveSectionPropertyOnView", function refreshActiveSectionPropertyOnView() {
    this.refreshToolbarActions();
  }), "refreshUnsavedAttachmentsPropertyOnView", function refreshUnsavedAttachmentsPropertyOnView() {
    this.refreshToolbarActions();
  }), "refreshToolbarActions", function refreshToolbarActions() {
    this.getView().refreshToolbarActions(this.getFormActions());
  }), "refreshActions", function refreshActions() {
    this.refreshToolbarActions();
    if (this.getActiveSection()) {
      this.getActiveSection().refreshSectionActions();
    }
  }), "requestAttachmentsUpload", function requestAttachmentsUpload(title, currentFiles, multiple, modalOptions) {
    var options = _.extend(modalOptions || {}, {
      title: title,
      files: currentFiles,
      documentId: this.getDocumentModel() ? this.getDocumentModel().id : null,
      multiSelect: multiple || false
    });
    return UploadModal.show(options);
  }), "requestSectionActivate", function requestSectionActivate(section) {
    return this.activateSection(section);
  }), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_Vertebrae$Controller, "answersDidSave", function answersDidSave(options) {
    var sections = this.getSections();
    if (options && options.all) {
      for (var s = 0, len = sections.length; s < len; s++) {
        sections[s].setUnsavedChanges(false);
      }
    } else {
      this.getActiveSection().setUnsavedChanges(false);
    }
    this.setUnsavedAttachments(false);
    this.refreshActions();
  }), "clearAssignmentFormObject", function clearAssignmentFormObject(assignment, fo) {
    var map = this.getAssignmentFormObjectsMap();
    if (map[assignment] === fo) {
      delete map[assignment];
    }
    return this;
  }), "setAssignmentFormObject", function setAssignmentFormObject(assignment, fo) {
    var map = this.getAssignmentFormObjectsMap();
    map[assignment] = fo;
    return this;
  }), "getAssignmentFormObject", function getAssignmentFormObject(assignment) {
    var map = this.getAssignmentFormObjectsMap();
    return map[assignment];
  }), "addAssignmentFormObject", function addAssignmentFormObject(fo) {
    this.getAssignmentFormObjects().push(fo);
  }), "getAssignmentTypeByDescription", function getAssignmentTypeByDescription(description) {
    return AssignmentBuilder.getAssignmentType(description);
  }), "loadAssignmentsToBuilder", function loadAssignmentsToBuilder(ab) {
    var fos = this.getAssignmentFormObjects(),
      len = fos ? fos.length : 0,
      i = 0;
    for (i = 0, fo; i < len; ++i) {
      fo = fos[i];
      if (fo.isVisible()) {
        fo.loadAssignmentsToBuilder(ab);
      }
    }
  }), "addSaveHandler", function addSaveHandler(fn) {
    this.getSaveHandlers().push(fn);
  }), "requestSaveHandlers", function requestSaveHandlers() {
    return Promise.map(this.getSaveHandlers(), function (fn) {
      return fn();
    });
  }), "requestNextSectionAction", function requestNextSectionAction() {
    return this.activateNextVisibleSection();
  }), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_Vertebrae$Controller, "requestPreviousSectionAction", function requestPreviousSectionAction() {
    return this.activatePreviousVisibleSection();
  }), "hasUnsavedSections", function hasUnsavedSections() {
    var sections = this.getVisibleSections();
    return _.some(sections, function (section) {
      return section.getUnsavedChanges();
    });
  }), "requestPdfAction", function requestPdfAction() {
    this.getDelegate().generatePDFDocument();
  }), "requestCompareAction", function requestCompareAction() {
    var section = _.indexOf(this.getSections(), this.getActiveSection());
    section = section >= 0 ? section : null;
    this.getAppController().navigateDiff(this.getDocumentModel(), {
      trigger: true
    }, section);
  }), "requestSaveAction", function requestSaveAction(options) {
    var documentModel = this.getDocumentModel(),
      answerData = this.getAnswerData(options),
      id = this.getActiveSection().id,
      ab = new AssignmentBuilder({
        document: documentModel
      }),
      workflowService = this.getWorkflowService(),
      documentLock = this.getDocumentLock();
    this.loadAssignmentsToBuilder(ab);
    return documentLock.setLock(id).bind(this).then(function () {
      return this.requestSaveHandlers();
    }).then(function () {
      return documentModel.saveAnswerData(answerData, id);
    }).then(function () {
      this.noSavesInAnswers = false;
      return ab.requestApply();
    }).tap(function () {
      this.answersDidSave(options);
    }).tap(function () {
      if (workflowService) {
        return workflowService.getDocumentService().update('assignments');
      }
    }).lastly(this.loadingForPromise());
  }), "requestMakeAssignments", function requestMakeAssignments(assignments) {
    var documentModel = this.getDocumentModel();
    return documentModel.requestMakeAssignments(assignments);
  }), "requestMakeSponsorAssignment", function requestMakeSponsorAssignment(assignment) {
    var documentModel = this.getDocumentModel();
    return documentModel.requestMakeSponsorAssignments(assignment);
  }), "requestAttachmentAction", function requestAttachmentAction(attachment, modalOptions) {
    if (this.canEditDocument()) {
      attachment.requestDocumentUpload(modalOptions);
    } else {
      attachment.requestDocumentView();
    }
  }), "requestStudyAction", function requestStudyAction() {
    var doc = this.getDocumentModel(),
      app = this.getAppController();
    app.navigateStudy({
      id: doc.getStudyId(),
      documentId: doc.getId()
    }, {
      trigger: true
    });
  }), "requestEditAction", function requestEditAction() {
    this.getAppController().navigateTemplate(this.getTemplateModel(), {
      trigger: true
    });
  }), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_Vertebrae$Controller, "refreshAllAnswers", function refreshAllAnswers() {
    var formObjectData = {},
      documentModel = this.getDocumentModel();
    return documentModel.requestAnswerData().bind(this).then(function (answers) {
      this.applyAnswerData(answers);
      for (var i = 0, len = answers.length; i < len; i++) {
        formObjectData[answers[i].id] = answers[i];
      }
      this.setFormObjectData(formObjectData);
    });
  }), "requestWorkflowAction", function requestWorkflowAction(value) {
    var workflowService = this.getWorkflowService();
    return this.refreshLocks().bind(this).caught(function () {}).tap(function () {
      var sections = this.getSections(),
        section = null,
        len = sections.length,
        i = 0;
      for (i = 0; i < len; ++i) {
        section = sections[i];
        if (section.isExternallyLocked()) {
          E3Modal.BtnMsgModal.show({
            title: 'Warning',
            message: 'This document has locks from other users.',
            buttons: 'Close'
          });
          return Promise.reject().ignore();
        }
      }
      if (this.hasUnsavedSections()) {
        return this.requestSaveAction({
          all: true
        });
      }
    }).tap(function () {
      if (workflowService.getTaskName() == 'EDIT_COMPLETE') {}
    }).tap(function () {
      return workflowService.update('tasks');
    }).tap(function () {
      return workflowService.getDocumentService().update('assignments');
    }).tap(function () {
      return this.refreshComments();
    }).lastly(this.showLoading()).tap(function () {
      if (workflowService.getTaskName() == 'EDIT_COMPLETE' && this.getComments().length) {
        throw new Error('All comments must be addressed before this submission is completed.');
      }
    }).tap(function () {
      if (this.isValid()) {
        return WorkflowModal.show({
          answerValue: value,
          workflowService: workflowService,
          buttons: [{
            text: 'Cancel',
            icon: 'ban'
          }, {
            text: 'Confirm',
            color: 'primary',
            icon: 'check'
          }]
        }).bind(this).then(function (btn) {
          if (btn === 'Cancel') {
            $('.form-sidebar-action-btn')[0].focus();
            return Promise.reject().ignore();
          }
        });
      }
      throw new Error('You have not completed this submission!');
    }).tap(function () {
      return workflowService.answerTask(value).lastly(this.showLoading());
    }).tap(this.requestStudyAction);
  }), "requestWorkflowRestart", function requestWorkflowRestart() {
    var workflowService = this.getWorkflowService();
    return workflowService.restart().lastly(this.showLoading());
  }), "canEditDocument", function canEditDocument() {
    if (this.isLockingEnabled() && !this.getReadOnly()) {
      return true;
    }
    return false;
  }), "isLockingEnabled", function isLockingEnabled() {
    var permissions = this.getPermissions();
    if (this.getDocumentLock() && !this.isDesignerMode() && !this.isPreviewMode() && permissions.canWrite) {
      return true;
    }
    return false;
  }), "refreshLocks", function refreshLocks() {
    return this.getDocumentLock().updateLockList();
  }), "isDesignerMode", function isDesignerMode() {
    return false;
  }), "isPDFMode", function isPDFMode() {
    return false;
  }), "isDiffViewer", function isDiffViewer() {
    return false;
  }), "isPreviewMode", function isPreviewMode() {
    return !!this.getTemplateModel().preview;
  }), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_Vertebrae$Controller, "unlockModels", function unlockModels() {}), "unload", function unload() {
    this._super();
    return Promise.resolve(this.unlockModels());
  }), "toJSON", function toJSON() {
    var sections = this.getSections(),
      children = [],
      i = 0,
      len = sections ? sections.length : 0;
    for (i = 0; i < len; ++i) {
      children.push(sections[i].toJSON());
    }
    return {
      children: children,
      attachments: this.getAttachments()
    };
  }), "highlightFormObject", function highlightFormObject(formObject) {
    var view = formObject.getView(),
      el = view.$el,
      time = 200,
      remaining = 0,
      doFrame = null,
      inverse = false,
      start = null,
      handle = null;
    handle = function handle(ratio) {
      if (inverse) {
        ratio = 1 - ratio;
      }
      el.css('outline', '2px solid rgba(255, 175, 35, ' + ratio + ')');
    };
    doFrame = function doFrame() {
      var d = Promise.defer(),
        _doFrameHandle = null;
      start = new Date();
      remaining = time;
      handle(0);
      _doFrameHandle = function doFrameHandle() {
        remaining = time - (new Date() - start);
        if (remaining > 0) {
          handle(1 - remaining / time);
          setTimeout(_doFrameHandle, 1);
        } else {
          handle(1);
          d.resolve();
        }
      };
      setTimeout(_doFrameHandle, 1);
      return d.promise;
    };
    return doFrame().then(function () {
      inverse = true;
      return doFrame();
    }).then(function () {
      inverse = false;
      return doFrame();
    }).then(function () {
      inverse = true;
      return doFrame();
    }).then(function () {
      el.css('outline', '');
    });
  }), "revealFormObject", function revealFormObject(formObject) {
    var section = formObject.getSectionController();
    if (section) {
      return this.activateSection(section).bind(this).then(function () {
        return this.scrollToFormObject(formObject);
      });
    }
    return Promise.resolve();
  }), "scrollToFormObject", function scrollToFormObject(formObject) {
    if (formObject) {
      return this.getView().scrollToFormObject(formObject);
    }
    return Promise.resolve();
  }), "requestPreviousContentController", function requestPreviousContentController() {
    this.requestStudyAction();
  }), "trackFormEvent", function trackFormEvent(event, properties) {
    this.getAppController().trackEvent(event, properties);
  })));
  module.exports = FormContentController;
});

